class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  }

  connectedCallback() {
    this.hoverEvents = new AbortController();
    const options = { signal: this.hoverEvents.signal };
    this.addEventListener('pointerenter', (event) => {
      if (!this.hoverQuery.matches || event.pointerType !== 'mouse') return;
      clearTimeout(this.closeTimer);
      this.closest('.header__inline-menu')?.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
      this.mainDetailsToggle.open = true;
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    }, options);
    this.addEventListener('pointerleave', (event) => {
      if (!this.hoverQuery.matches || event.pointerType !== 'mouse') return;
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 180);
    }, options);
    this.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape' || !this.mainDetailsToggle.open) return;
      clearTimeout(this.closeTimer);
      this.close();
      this.mainDetailsToggle.querySelector('summary').focus();
    }, options);
    this.hoverQuery.addEventListener('change', () => {
      clearTimeout(this.closeTimer);
      if (!this.hoverQuery.matches) this.close();
    }, options);
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimer);
    this.hoverEvents?.abort();
  }

  onToggle() {
    if (!this.header) return;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
